// assets
import {
    IconDashboard,
    IconSettings,
    IconList,
    IconRobot,
    IconTable,
    IconCubeSend,
    IconChartTreemap,
    IconUsers,
    IconChartBar,
    IconArchive,
    IconAntenna
} from '@tabler/icons-react';

// constant
const icons = {
    IconDashboard,
    IconSettings,
    IconList,
    IconRobot,
    IconTable,
    IconCubeSend,
    IconChartTreemap,
    IconUsers,
    IconChartBar,
    IconArchive,
    IconAntenna
};

// ==============================|| ADMIN MENU ITEMS ||============================== //

const adminMenuItems = {
    items: [
        {
            id: 'admin',
            title: 'Admin',
            type: 'group',
            admin: true,
            children: [
                {
                    id: 'sensores',
                    title: 'Sensores',
                    type: 'item',
                    url: '/admin/sensores',
                    admin: true,
                    icon: icons.IconAntenna,
                    breadcrumbs: false
                },
                {
                    id: 'admin-usuarios',
                    title: 'Administrar Usuarios',
                    type: 'item',
                    url: '/admin/usuarios',
                    admin: true,
                    icon: icons.IconUsers,
                    breadcrumbs: false
                },
                {
                    id: 'configurar-id-dispositivo',
                    title: 'Configurar id del dispositivo',
                    type: 'item',
                    url: '/admin/configurar-id-dispositivo',
                    admin: true,
                    icon: icons.IconSettings,
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export default adminMenuItems;
